const Divider = ({text}) => (
  <div className="divider">
      <h1 className="divider-text">{text}</h1>
  </div>
);

export default Divider;
